import { createContext, useContext } from 'react';
import type { PendingConflict } from './conflictHandler';

export type ConflictContextType = {
    conflicts: PendingConflict[];
    addConflict: (conflict: PendingConflict) => void;
};

export const ConflictContext = createContext<ConflictContextType>({
    conflicts: [],
    addConflict: () => {}
});

export function useConflicts() {
    return useContext(ConflictContext);
}
